"use strict";
// SYSTEM_GENERATED_ENUM_START
exports.__esModule = true;
exports.E_SERVICE_STATUS = exports.SUBMISSION_FORM_CALCULATED_FIELDS = exports.PERCENTAGE_VALUE_TYPE = exports.TFA_TIME_LIMIT = exports.USER_ROLE = exports.FRANCHISE = exports.BANK_TRANSACTION_TYPE = exports.MONTH_DAYS = exports.BANK_TYPE = exports.DOCUMENT_HISTORY_OPERATION = exports.WEEK_DAYS = exports.BUSINESS_ENTITY_EMAIL_TYPE = exports.REPORT_COMPARISON_TYPE = exports.REPORT_INTERVAL = exports.MASTER_CLIENT_FEATURE = exports.REPORT_TYPES = exports.ACTION_LOG_TYPE = exports.COUNTY_VENDORS = exports.BOT_STATUS = exports.BOT_TYPE_CATEGORY = exports.BOT_PROCESS_INTERVAL = exports.GLOBAL_SETTING_FIELD_TYPE = exports.BOT_PROCESS_QUEUE_STATUS = exports.BOT_PROCESS_MACHINE_CAPABILITY = exports.CLIENT_DETAIL_EXTRACT_STATUS = exports.BOT_PROCESS_OPERATING_SYSTEM = exports.SUB_CLIENT_TAX_FORM = exports.INCOME_TYPE = exports.CRON_LOG_STATUS = exports.TAX_FILING_STATUS = exports.FREQUENCY_OF_FILING = exports.TAX_PROCESS_FINAL_STEP = exports.BOT_PROCESS_ENTITY_TYPE_CODE = exports.FIELD_TYPE = exports.REVENUE_TYPE = exports.ADMIN_ROLES = exports.MESSAGE_TYPE = exports.SUB_CLIENT_REPORTING_PATTERN = exports.SUB_CLIENT_REVENUE_SUBMISSION_TYPE = exports.BANK_ACCOUNT_TYPE = exports.SUB_CLIENT_BUSINESS_TYPE = void 0;
var SUB_CLIENT_BUSINESS_TYPE;
(function (SUB_CLIENT_BUSINESS_TYPE) {
    SUB_CLIENT_BUSINESS_TYPE["CONVENIENCE_STORE"] = "CONVENIENCE_STORE";
    SUB_CLIENT_BUSINESS_TYPE["HOTEL"] = "HOTEL";
    SUB_CLIENT_BUSINESS_TYPE["RETAIL_STORE"] = "RETAIL_STORE";
    SUB_CLIENT_BUSINESS_TYPE["WAREHOUSE"] = "WAREHOUSE";
    SUB_CLIENT_BUSINESS_TYPE["COMMERCIAL_RENTAL"] = "COMMERCIAL_RENTAL";
    SUB_CLIENT_BUSINESS_TYPE["AMUSMENT_MACHINE_REPORT"] = "AMUSMENT_MACHINE_REPORT";
    SUB_CLIENT_BUSINESS_TYPE["ELECTRICITY"] = "ELECTRICITY";
    SUB_CLIENT_BUSINESS_TYPE["OTHER_BUSINESS"] = "OTHER_BUSINESS";
    SUB_CLIENT_BUSINESS_TYPE["HOSPITALITY"] = "HOSPITALITY";
})(SUB_CLIENT_BUSINESS_TYPE = exports.SUB_CLIENT_BUSINESS_TYPE || (exports.SUB_CLIENT_BUSINESS_TYPE = {}));
var BANK_ACCOUNT_TYPE;
(function (BANK_ACCOUNT_TYPE) {
    BANK_ACCOUNT_TYPE["_1"] = "1";
    BANK_ACCOUNT_TYPE["_2"] = "2";
    BANK_ACCOUNT_TYPE["_3"] = "3";
})(BANK_ACCOUNT_TYPE = exports.BANK_ACCOUNT_TYPE || (exports.BANK_ACCOUNT_TYPE = {}));
var SUB_CLIENT_REVENUE_SUBMISSION_TYPE;
(function (SUB_CLIENT_REVENUE_SUBMISSION_TYPE) {
    SUB_CLIENT_REVENUE_SUBMISSION_TYPE["SUB_CLIENT"] = "SUB_CLIENT";
    SUB_CLIENT_REVENUE_SUBMISSION_TYPE["MASTER_CLIENT"] = "MASTER_CLIENT";
    SUB_CLIENT_REVENUE_SUBMISSION_TYPE["AUTOMATION_UNATTENDED"] = "AUTOMATION_UNATTENDED";
    SUB_CLIENT_REVENUE_SUBMISSION_TYPE["READING_REPORT_FROM_EMAIL"] = "READING_REPORT_FROM_EMAIL";
    SUB_CLIENT_REVENUE_SUBMISSION_TYPE["READING_REPORT_FROM_PMS_POS"] = "READING_REPORT_FROM_PMS_POS";
})(SUB_CLIENT_REVENUE_SUBMISSION_TYPE = exports.SUB_CLIENT_REVENUE_SUBMISSION_TYPE || (exports.SUB_CLIENT_REVENUE_SUBMISSION_TYPE = {}));
var SUB_CLIENT_REPORTING_PATTERN;
(function (SUB_CLIENT_REPORTING_PATTERN) {
    SUB_CLIENT_REPORTING_PATTERN["FIXED"] = "FIXED";
    SUB_CLIENT_REPORTING_PATTERN["NO_ACTIVITY"] = "NO_ACTIVITY";
    SUB_CLIENT_REPORTING_PATTERN["VARIABLE"] = "VARIABLE";
})(SUB_CLIENT_REPORTING_PATTERN = exports.SUB_CLIENT_REPORTING_PATTERN || (exports.SUB_CLIENT_REPORTING_PATTERN = {}));
var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["EMAIL"] = "EMAIL";
    MESSAGE_TYPE["SMS"] = "SMS";
    MESSAGE_TYPE["NOTIFICATION"] = "NOTIFICATION";
})(MESSAGE_TYPE = exports.MESSAGE_TYPE || (exports.MESSAGE_TYPE = {}));
var ADMIN_ROLES;
(function (ADMIN_ROLES) {
    ADMIN_ROLES["SYSTEM_ADMIN"] = "SYSTEM_ADMIN";
    ADMIN_ROLES["ORGANIZATION_ADMIN"] = "ORGANIZATION_ADMIN";
    ADMIN_ROLES["SYS_MANAGER"] = "SYS_MANAGER";
})(ADMIN_ROLES = exports.ADMIN_ROLES || (exports.ADMIN_ROLES = {}));
var REVENUE_TYPE;
(function (REVENUE_TYPE) {
    REVENUE_TYPE["SALES_AND_SERVICE"] = "SALES_AND_SERVICE";
    REVENUE_TYPE["TAXABLE_PURCHASE"] = "TAXABLE_PURCHASE";
    REVENUE_TYPE["COMMERCIAL_RENTAL"] = "COMMERCIAL_RENTAL";
    REVENUE_TYPE["TRANSIENT_RENTALS"] = "TRANSIENT_RENTALS";
    REVENUE_TYPE["FOOD_AND_BEVERAGE"] = "FOOD_AND_BEVERAGE";
})(REVENUE_TYPE = exports.REVENUE_TYPE || (exports.REVENUE_TYPE = {}));
var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE["REVENUE"] = "REVENUE";
    FIELD_TYPE["FILE"] = "FILE";
    FIELD_TYPE["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    FIELD_TYPE["NOTE"] = "NOTE";
    FIELD_TYPE["CALCULATED_FIELDS"] = "CALCULATED_FIELDS";
})(FIELD_TYPE = exports.FIELD_TYPE || (exports.FIELD_TYPE = {}));
var BOT_PROCESS_ENTITY_TYPE_CODE;
(function (BOT_PROCESS_ENTITY_TYPE_CODE) {
    BOT_PROCESS_ENTITY_TYPE_CODE["BANK"] = "BANK";
    BOT_PROCESS_ENTITY_TYPE_CODE["VENDOR"] = "VENDOR";
    BOT_PROCESS_ENTITY_TYPE_CODE["CLIENT"] = "CLIENT";
})(BOT_PROCESS_ENTITY_TYPE_CODE = exports.BOT_PROCESS_ENTITY_TYPE_CODE || (exports.BOT_PROCESS_ENTITY_TYPE_CODE = {}));
var TAX_PROCESS_FINAL_STEP;
(function (TAX_PROCESS_FINAL_STEP) {
    TAX_PROCESS_FINAL_STEP["SAVE_AND_SUBMIT_LATER"] = "SAVE_AND_SUBMIT_LATER";
    TAX_PROCESS_FINAL_STEP["SUBMIT_WITH_PAYMENT"] = "SUBMIT_WITH_PAYMENT";
})(TAX_PROCESS_FINAL_STEP = exports.TAX_PROCESS_FINAL_STEP || (exports.TAX_PROCESS_FINAL_STEP = {}));
var FREQUENCY_OF_FILING;
(function (FREQUENCY_OF_FILING) {
    FREQUENCY_OF_FILING["MONTHLY"] = "MONTHLY";
    FREQUENCY_OF_FILING["QUARTERLY"] = "QUARTERLY";
    FREQUENCY_OF_FILING["ANNUALLY"] = "ANNUALLY";
    FREQUENCY_OF_FILING["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
})(FREQUENCY_OF_FILING = exports.FREQUENCY_OF_FILING || (exports.FREQUENCY_OF_FILING = {}));
var TAX_FILING_STATUS;
(function (TAX_FILING_STATUS) {
    TAX_FILING_STATUS["PENDING_REVENUE"] = "PENDING_REVENUE";
    TAX_FILING_STATUS["PROCESSING"] = "PROCESSING";
    TAX_FILING_STATUS["FAILED"] = "FAILED";
    TAX_FILING_STATUS["SUCCESS"] = "SUCCESS";
    TAX_FILING_STATUS["REVENUE_SUBMITTED"] = "REVENUE_SUBMITTED";
    TAX_FILING_STATUS["READY_TO_FILE_TAX"] = "READY_TO_FILE_TAX";
    TAX_FILING_STATUS["FILING_STARTED"] = "FILING_STARTED";
    TAX_FILING_STATUS["PENDING_REVIEW"] = "PENDING_REVIEW";
    TAX_FILING_STATUS["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
    TAX_FILING_STATUS["PENDING_FOR_PAYMENT"] = "PENDING_FOR_PAYMENT";
    TAX_FILING_STATUS["WAITING_TO_BE_STARTED"] = "WAITING_TO_BE_STARTED";
    TAX_FILING_STATUS["FILED_BY_OTHERS"] = "FILED_BY_OTHERS";
})(TAX_FILING_STATUS = exports.TAX_FILING_STATUS || (exports.TAX_FILING_STATUS = {}));
var CRON_LOG_STATUS;
(function (CRON_LOG_STATUS) {
    CRON_LOG_STATUS["RUNNING"] = "RUNNING";
    CRON_LOG_STATUS["SUCCESS"] = "SUCCESS";
    CRON_LOG_STATUS["FAILED"] = "FAILED";
})(CRON_LOG_STATUS = exports.CRON_LOG_STATUS || (exports.CRON_LOG_STATUS = {}));
var INCOME_TYPE;
(function (INCOME_TYPE) {
    INCOME_TYPE["SALES_AND_SERVICE_GROSS_REVENUE"] = "SALES_AND_SERVICE_GROSS_REVENUE";
    INCOME_TYPE["SALES_AND_SERVICE_EXEMPT_REVENUE"] = "SALES_AND_SERVICE_EXEMPT_REVENUE";
    INCOME_TYPE["COMMERCIAL_RENTAL_GROSS_REVENUE"] = "COMMERCIAL_RENTAL_GROSS_REVENUE";
    INCOME_TYPE["COMMERCIAL_RENTAL_EXEMPT_REVENUE"] = "COMMERCIAL_RENTAL_EXEMPT_REVENUE";
    INCOME_TYPE["TRANSIENT_RENTALS_GROSS_REVENUE"] = "TRANSIENT_RENTALS_GROSS_REVENUE";
    INCOME_TYPE["TRANSIENT_RENTALS_EXEMPT_REVENUE"] = "TRANSIENT_RENTALS_EXEMPT_REVENUE";
    INCOME_TYPE["FOOD_AND_BEVERAGE_GROSS_REVENUE"] = "FOOD_AND_BEVERAGE_GROSS_REVENUE";
    INCOME_TYPE["FOOD_AND_BEVERAGE_EXEMPT_REVENUE"] = "FOOD_AND_BEVERAGE_EXEMPT_REVENUE";
    INCOME_TYPE["TAXABLE_PURCHASE"] = "TAXABLE_PURCHASE";
    INCOME_TYPE["TOTAL_TAX_COLLECTED"] = "TOTAL_TAX_COLLECTED";
    INCOME_TYPE["LAWFUL_DEDUCTIONS"] = "LAWFUL_DEDUCTIONS";
    INCOME_TYPE["ESTIMATE_TAX_DOR_MEMO"] = "ESTIMATE_TAX_DOR_MEMO";
    INCOME_TYPE["ESTIMATE_TAX_DUE_CURRENT_MONTH"] = "ESTIMATE_TAX_DUE_CURRENT_MONTH";
    INCOME_TYPE["PENALTY"] = "PENALTY";
    INCOME_TYPE["INTEREST"] = "INTEREST";
    INCOME_TYPE["ROW_15A"] = "ROW_15A";
    INCOME_TYPE["ROW_15B"] = "ROW_15B";
    INCOME_TYPE["ROW_15C"] = "ROW_15C";
    INCOME_TYPE["SALES_AND_SERVICE_NET_REVENUE"] = "SALES_AND_SERVICE_NET_REVENUE";
    INCOME_TYPE["COMMERCIAL_RENTAL_NET_REVENUE"] = "COMMERCIAL_RENTAL_NET_REVENUE";
    INCOME_TYPE["TRANSIENT_RENTALS_NET_REVENUE"] = "TRANSIENT_RENTALS_NET_REVENUE";
    INCOME_TYPE["FOOD_AND_BEVERAGE_NET_REVENUE"] = "FOOD_AND_BEVERAGE_NET_REVENUE";
})(INCOME_TYPE = exports.INCOME_TYPE || (exports.INCOME_TYPE = {}));
var SUB_CLIENT_TAX_FORM;
(function (SUB_CLIENT_TAX_FORM) {
    SUB_CLIENT_TAX_FORM["DR15"] = "DR15";
    SUB_CLIENT_TAX_FORM["DR15EZ"] = "DR15EZ";
    SUB_CLIENT_TAX_FORM["DR15CON"] = "DR15CON";
    SUB_CLIENT_TAX_FORM["DR7"] = "DR7";
})(SUB_CLIENT_TAX_FORM = exports.SUB_CLIENT_TAX_FORM || (exports.SUB_CLIENT_TAX_FORM = {}));
var BOT_PROCESS_OPERATING_SYSTEM;
(function (BOT_PROCESS_OPERATING_SYSTEM) {
    BOT_PROCESS_OPERATING_SYSTEM["WINDOWS"] = "WINDOWS";
    BOT_PROCESS_OPERATING_SYSTEM["MAC"] = "MAC";
    BOT_PROCESS_OPERATING_SYSTEM["LINUX"] = "LINUX";
})(BOT_PROCESS_OPERATING_SYSTEM = exports.BOT_PROCESS_OPERATING_SYSTEM || (exports.BOT_PROCESS_OPERATING_SYSTEM = {}));
var CLIENT_DETAIL_EXTRACT_STATUS;
(function (CLIENT_DETAIL_EXTRACT_STATUS) {
    CLIENT_DETAIL_EXTRACT_STATUS["PENDING"] = "PENDING";
    CLIENT_DETAIL_EXTRACT_STATUS["SUCCESS"] = "SUCCESS";
    CLIENT_DETAIL_EXTRACT_STATUS["FAILED"] = "FAILED";
    CLIENT_DETAIL_EXTRACT_STATUS["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
})(CLIENT_DETAIL_EXTRACT_STATUS = exports.CLIENT_DETAIL_EXTRACT_STATUS || (exports.CLIENT_DETAIL_EXTRACT_STATUS = {}));
var BOT_PROCESS_MACHINE_CAPABILITY;
(function (BOT_PROCESS_MACHINE_CAPABILITY) {
    BOT_PROCESS_MACHINE_CAPABILITY["WEB"] = "WEB";
    BOT_PROCESS_MACHINE_CAPABILITY["UIPATH"] = "UIPATH";
    BOT_PROCESS_MACHINE_CAPABILITY["FIREBASE"] = "FIREBASE";
    BOT_PROCESS_MACHINE_CAPABILITY["WEB_SCREEN"] = "WEB_SCREEN";
})(BOT_PROCESS_MACHINE_CAPABILITY = exports.BOT_PROCESS_MACHINE_CAPABILITY || (exports.BOT_PROCESS_MACHINE_CAPABILITY = {}));
var BOT_PROCESS_QUEUE_STATUS;
(function (BOT_PROCESS_QUEUE_STATUS) {
    BOT_PROCESS_QUEUE_STATUS["COMPLETED"] = "COMPLETED";
    BOT_PROCESS_QUEUE_STATUS["PENDING"] = "PENDING";
    BOT_PROCESS_QUEUE_STATUS["RUNNING"] = "RUNNING";
    BOT_PROCESS_QUEUE_STATUS["STOPPED"] = "STOPPED";
})(BOT_PROCESS_QUEUE_STATUS = exports.BOT_PROCESS_QUEUE_STATUS || (exports.BOT_PROCESS_QUEUE_STATUS = {}));
var GLOBAL_SETTING_FIELD_TYPE;
(function (GLOBAL_SETTING_FIELD_TYPE) {
    GLOBAL_SETTING_FIELD_TYPE["TEXT"] = "TEXT";
    GLOBAL_SETTING_FIELD_TYPE["PASSWORD"] = "PASSWORD";
    GLOBAL_SETTING_FIELD_TYPE["RICHTEXT"] = "RICHTEXT";
    GLOBAL_SETTING_FIELD_TYPE["DROPDOWN"] = "DROPDOWN";
    GLOBAL_SETTING_FIELD_TYPE["BOOLEAN"] = "BOOLEAN";
})(GLOBAL_SETTING_FIELD_TYPE = exports.GLOBAL_SETTING_FIELD_TYPE || (exports.GLOBAL_SETTING_FIELD_TYPE = {}));
var BOT_PROCESS_INTERVAL;
(function (BOT_PROCESS_INTERVAL) {
    BOT_PROCESS_INTERVAL["ONE_TIME"] = "ONE_TIME";
    BOT_PROCESS_INTERVAL["DAILY"] = "DAILY";
    BOT_PROCESS_INTERVAL["MULTIPLE_TIMES_IN_DAY"] = "MULTIPLE_TIMES_IN_DAY";
    BOT_PROCESS_INTERVAL["WEEKLY"] = "WEEKLY";
    BOT_PROCESS_INTERVAL["MONTHLY"] = "MONTHLY";
    BOT_PROCESS_INTERVAL["EVERY_N_HOURS"] = "EVERY_N_HOURS";
})(BOT_PROCESS_INTERVAL = exports.BOT_PROCESS_INTERVAL || (exports.BOT_PROCESS_INTERVAL = {}));
var BOT_TYPE_CATEGORY;
(function (BOT_TYPE_CATEGORY) {
    BOT_TYPE_CATEGORY["POS_PMS"] = "POS_PMS";
    BOT_TYPE_CATEGORY["BANK_AND_Credit_Card"] = "BANK_AND_Credit_Card";
    BOT_TYPE_CATEGORY["ADVANCE_AUTOMATION_PROCESSING"] = "ADVANCE_AUTOMATION_PROCESSING";
})(BOT_TYPE_CATEGORY = exports.BOT_TYPE_CATEGORY || (exports.BOT_TYPE_CATEGORY = {}));
var BOT_STATUS;
(function (BOT_STATUS) {
    BOT_STATUS["PENDING"] = "PENDING";
    BOT_STATUS["QUEUED"] = "QUEUED";
    BOT_STATUS["SUCCESS"] = "SUCCESS";
    BOT_STATUS["FAILED"] = "FAILED";
    BOT_STATUS["SKIPPED"] = "SKIPPED";
    BOT_STATUS["ATTENDING"] = "ATTENDING";
    BOT_STATUS["RETRY"] = "RETRY";
    BOT_STATUS["WAITING"] = "WAITING";
    BOT_STATUS["ROLLED_OVER"] = "ROLLED_OVER";
    BOT_STATUS["NONE"] = "NONE";
})(BOT_STATUS = exports.BOT_STATUS || (exports.BOT_STATUS = {}));
var COUNTY_VENDORS;
(function (COUNTY_VENDORS) {
    COUNTY_VENDORS["TOURIST_EXPRESS"] = "TOURIST_EXPRESS";
    COUNTY_VENDORS["HOST_COMPLIANCE"] = "HOST_COMPLIANCE";
    COUNTY_VENDORS["EXCISE"] = "EXCISE";
})(COUNTY_VENDORS = exports.COUNTY_VENDORS || (exports.COUNTY_VENDORS = {}));
var ACTION_LOG_TYPE;
(function (ACTION_LOG_TYPE) {
    ACTION_LOG_TYPE["TAX_FILING_SUBMIT"] = "TAX_FILING_SUBMIT";
    ACTION_LOG_TYPE["TAX_FILING_APPROVE"] = "TAX_FILING_APPROVE";
    ACTION_LOG_TYPE["TAX_FILING_PROCESS"] = "TAX_FILING_PROCESS";
    ACTION_LOG_TYPE["TAX_FILING_RETRY"] = "TAX_FILING_RETRY";
    ACTION_LOG_TYPE["FILING_STATUS_CHANGE"] = "FILING_STATUS_CHANGE";
    ACTION_LOG_TYPE["SUB_CLIENT_STATUS_CHANGE"] = "SUB_CLIENT_STATUS_CHANGE";
    ACTION_LOG_TYPE["TAX_FILING_STAGE_SKIP"] = "TAX_FILING_STAGE_SKIP";
})(ACTION_LOG_TYPE = exports.ACTION_LOG_TYPE || (exports.ACTION_LOG_TYPE = {}));
var REPORT_TYPES;
(function (REPORT_TYPES) {
    REPORT_TYPES["JANAK_CASH_FLOW"] = "JANAK_CASH_FLOW";
    REPORT_TYPES["PDF_CASH_FLOW_MONTHLY_REVENUE_REPORT"] = "PDF_CASH_FLOW_MONTHLY_REVENUE_REPORT";
    REPORT_TYPES["PDF_CASH_FLOW_TOTAL_TAX_COLLECTED"] = "PDF_CASH_FLOW_TOTAL_TAX_COLLECTED";
    REPORT_TYPES["XLSX_ELISTAR_MONTHLY_REVENUE_REPORT"] = "XLSX_ELISTAR_MONTHLY_REVENUE_REPORT";
    REPORT_TYPES["PEP_TAX_REPORT"] = "PEP_TAX_REPORT";
    REPORT_TYPES["FOSSE_DAILY_CLOSING_REPORT"] = "FOSSE_DAILY_CLOSING_REPORT";
    REPORT_TYPES["SYNAXIS_STATISTICS_REPORT"] = "SYNAXIS_STATISTICS_REPORT";
    REPORT_TYPES["SYNAXIS_TRANSACTION_TOTALS_REPORT"] = "SYNAXIS_TRANSACTION_TOTALS_REPORT";
    REPORT_TYPES["REDISTAY_STATISTICS_REPORT"] = "REDISTAY_STATISTICS_REPORT";
    REPORT_TYPES["REDISTAY_TRANSACTION_TOTALS_REPORT"] = "REDISTAY_TRANSACTION_TOTALS_REPORT";
    REPORT_TYPES["CHOICE_ADVANTAGE_HOTEL_STATISTICS"] = "CHOICE_ADVANTAGE_HOTEL_STATISTICS";
    REPORT_TYPES["CHOICE_ADVANTAGE_FINAL_TRANSACTION"] = "CHOICE_ADVANTAGE_FINAL_TRANSACTION";
    REPORT_TYPES["MSI_TRANSACTION_TOTALS"] = "MSI_TRANSACTION_TOTALS";
    REPORT_TYPES["MSI_MANAGERS_REPORT"] = "MSI_MANAGERS_REPORT";
    REPORT_TYPES["MSI_TAX_EXEMPT_REPORT"] = "MSI_TAX_EXEMPT_REPORT";
})(REPORT_TYPES = exports.REPORT_TYPES || (exports.REPORT_TYPES = {}));
var MASTER_CLIENT_FEATURE;
(function (MASTER_CLIENT_FEATURE) {
    MASTER_CLIENT_FEATURE["REPORT_AUTOMATION"] = "REPORT_AUTOMATION";
    MASTER_CLIENT_FEATURE["TAX_FILING_AUTOMATION"] = "TAX_FILING_AUTOMATION";
    MASTER_CLIENT_FEATURE["RECONCILE_BANK_INFORMATION"] = "RECONCILE_BANK_INFORMATION";
    MASTER_CLIENT_FEATURE["DOCUMENT_DOWNLOADER"] = "DOCUMENT_DOWNLOADER";
    MASTER_CLIENT_FEATURE["BANK_AUTOMATION"] = "BANK_AUTOMATION";
})(MASTER_CLIENT_FEATURE = exports.MASTER_CLIENT_FEATURE || (exports.MASTER_CLIENT_FEATURE = {}));
var REPORT_INTERVAL;
(function (REPORT_INTERVAL) {
    REPORT_INTERVAL["WEEKLY"] = "WEEKLY";
    REPORT_INTERVAL["DAILY"] = "DAILY";
    REPORT_INTERVAL["MONTHLY"] = "MONTHLY";
})(REPORT_INTERVAL = exports.REPORT_INTERVAL || (exports.REPORT_INTERVAL = {}));
var REPORT_COMPARISON_TYPE;
(function (REPORT_COMPARISON_TYPE) {
    REPORT_COMPARISON_TYPE["DAY_VS_DAY"] = "DAY_VS_DAY";
    REPORT_COMPARISON_TYPE["DATE_VS_DATE"] = "DATE_VS_DATE";
})(REPORT_COMPARISON_TYPE = exports.REPORT_COMPARISON_TYPE || (exports.REPORT_COMPARISON_TYPE = {}));
var BUSINESS_ENTITY_EMAIL_TYPE;
(function (BUSINESS_ENTITY_EMAIL_TYPE) {
    BUSINESS_ENTITY_EMAIL_TYPE["WAKEUP_REPORT"] = "WAKEUP_REPORT";
    BUSINESS_ENTITY_EMAIL_TYPE["HOURLY_REPORT"] = "HOURLY_REPORT";
})(BUSINESS_ENTITY_EMAIL_TYPE = exports.BUSINESS_ENTITY_EMAIL_TYPE || (exports.BUSINESS_ENTITY_EMAIL_TYPE = {}));
var WEEK_DAYS;
(function (WEEK_DAYS) {
    WEEK_DAYS["_0"] = "0";
    WEEK_DAYS["_1"] = "1";
    WEEK_DAYS["_2"] = "2";
    WEEK_DAYS["_3"] = "3";
    WEEK_DAYS["_4"] = "4";
    WEEK_DAYS["_5"] = "5";
    WEEK_DAYS["_6"] = "6";
})(WEEK_DAYS = exports.WEEK_DAYS || (exports.WEEK_DAYS = {}));
var DOCUMENT_HISTORY_OPERATION;
(function (DOCUMENT_HISTORY_OPERATION) {
    DOCUMENT_HISTORY_OPERATION["UPDATEONE"] = "UPDATEONE";
    DOCUMENT_HISTORY_OPERATION["DELETE"] = "DELETE";
})(DOCUMENT_HISTORY_OPERATION = exports.DOCUMENT_HISTORY_OPERATION || (exports.DOCUMENT_HISTORY_OPERATION = {}));
var BANK_TYPE;
(function (BANK_TYPE) {
    BANK_TYPE["TRUIST"] = "TRUIST";
    BANK_TYPE["CAPITAL_ONE_CC"] = "CAPITAL_ONE_CC";
    BANK_TYPE["PLAINS_CAPITAL"] = "PLAINS_CAPITAL";
    BANK_TYPE["JEFFERSON_BANK"] = "JEFFERSON_BANK";
    BANK_TYPE["AMERIS_BANK"] = "AMERIS_BANK";
    BANK_TYPE["CHASE_CC"] = "CHASE_CC";
    BANK_TYPE["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    BANK_TYPE["REGIONS_BANK"] = "REGIONS_BANK";
})(BANK_TYPE = exports.BANK_TYPE || (exports.BANK_TYPE = {}));
var MONTH_DAYS;
(function (MONTH_DAYS) {
    MONTH_DAYS["_1"] = "1";
    MONTH_DAYS["_2"] = "2";
    MONTH_DAYS["_3"] = "3";
    MONTH_DAYS["_4"] = "4";
    MONTH_DAYS["_5"] = "5";
    MONTH_DAYS["_6"] = "6";
    MONTH_DAYS["_7"] = "7";
    MONTH_DAYS["_8"] = "8";
    MONTH_DAYS["_9"] = "9";
    MONTH_DAYS["_10"] = "10";
    MONTH_DAYS["_11"] = "11";
    MONTH_DAYS["_12"] = "12";
    MONTH_DAYS["_13"] = "13";
    MONTH_DAYS["_14"] = "14";
    MONTH_DAYS["_15"] = "15";
    MONTH_DAYS["_16"] = "16";
    MONTH_DAYS["_17"] = "17";
    MONTH_DAYS["_18"] = "18";
    MONTH_DAYS["_19"] = "19";
    MONTH_DAYS["_20"] = "20";
    MONTH_DAYS["_21"] = "21";
    MONTH_DAYS["_22"] = "22";
    MONTH_DAYS["_23"] = "23";
    MONTH_DAYS["_24"] = "24";
    MONTH_DAYS["_25"] = "25";
    MONTH_DAYS["_26"] = "26";
    MONTH_DAYS["_27"] = "27";
    MONTH_DAYS["_28"] = "28";
    MONTH_DAYS["_29"] = "29";
    MONTH_DAYS["_30"] = "30";
    MONTH_DAYS["_31"] = "31";
})(MONTH_DAYS = exports.MONTH_DAYS || (exports.MONTH_DAYS = {}));
var BANK_TRANSACTION_TYPE;
(function (BANK_TRANSACTION_TYPE) {
    BANK_TRANSACTION_TYPE["QBO"] = "QBO";
    BANK_TRANSACTION_TYPE["CSV"] = "CSV";
})(BANK_TRANSACTION_TYPE = exports.BANK_TRANSACTION_TYPE || (exports.BANK_TRANSACTION_TYPE = {}));
var FRANCHISE;
(function (FRANCHISE) {
    FRANCHISE["BEST_WESTERN_HOTELS"] = "BEST_WESTERN_HOTELS";
})(FRANCHISE = exports.FRANCHISE || (exports.FRANCHISE = {}));
var USER_ROLE;
(function (USER_ROLE) {
    USER_ROLE["MASTER_ADMIN"] = "MASTER_ADMIN";
    USER_ROLE["MASTER_STAFF"] = "MASTER_STAFF";
    USER_ROLE["SUB_CLIENT_USER"] = "SUB_CLIENT_USER";
    USER_ROLE["SYSTEM_ADMIN"] = "SYSTEM_ADMIN";
    USER_ROLE["ORGANIZATION_ADMIN"] = "ORGANIZATION_ADMIN";
    USER_ROLE["PUBLIC"] = "PUBLIC";
    USER_ROLE["SUB_CLIENT_OWNER"] = "SUB_CLIENT_OWNER";
    USER_ROLE["MASTER_DOWNLOADER"] = "MASTER_DOWNLOADER";
    USER_ROLE["ENTITY_ADMIN"] = "ENTITY_ADMIN";
    USER_ROLE["SYS_MANAGER"] = "SYS_MANAGER";
    USER_ROLE["AUTHENTICATED"] = "AUTHENTICATED";
    USER_ROLE["NONE"] = "NONE";
})(USER_ROLE = exports.USER_ROLE || (exports.USER_ROLE = {}));
var TFA_TIME_LIMIT;
(function (TFA_TIME_LIMIT) {
    TFA_TIME_LIMIT["ONCE_A_DAY"] = "ONCE_A_DAY";
    TFA_TIME_LIMIT["HOURS"] = "HOURS";
})(TFA_TIME_LIMIT = exports.TFA_TIME_LIMIT || (exports.TFA_TIME_LIMIT = {}));
var PERCENTAGE_VALUE_TYPE;
(function (PERCENTAGE_VALUE_TYPE) {
    PERCENTAGE_VALUE_TYPE["PERCENTAGE"] = "PERCENTAGE";
    PERCENTAGE_VALUE_TYPE["AMOUNT"] = "AMOUNT";
})(PERCENTAGE_VALUE_TYPE = exports.PERCENTAGE_VALUE_TYPE || (exports.PERCENTAGE_VALUE_TYPE = {}));
var SUBMISSION_FORM_CALCULATED_FIELDS;
(function (SUBMISSION_FORM_CALCULATED_FIELDS) {
    SUBMISSION_FORM_CALCULATED_FIELDS["COMMERCIAL_RENTAL_GROSS_REVENUE"] = "COMMERCIAL_RENTAL_GROSS_REVENUE";
    SUBMISSION_FORM_CALCULATED_FIELDS["TRANSIENT_RENTALS_GROSS_REVENUE"] = "TRANSIENT_RENTALS_GROSS_REVENUE";
    SUBMISSION_FORM_CALCULATED_FIELDS["SALES_AND_SERVICE_GROSS_REVENUE"] = "SALES_AND_SERVICE_GROSS_REVENUE";
    SUBMISSION_FORM_CALCULATED_FIELDS["FOOD_AND_BEVERAGE_GROSS_REVENUE"] = "FOOD_AND_BEVERAGE_GROSS_REVENUE";
    SUBMISSION_FORM_CALCULATED_FIELDS["COMMERCIAL_RENTAL_INCLUSIVE"] = "COMMERCIAL_RENTAL_INCLUSIVE";
    SUBMISSION_FORM_CALCULATED_FIELDS["TRANSIENT_RENTALS_INCLUSIVE"] = "TRANSIENT_RENTALS_INCLUSIVE";
    SUBMISSION_FORM_CALCULATED_FIELDS["SALES_AND_SERVICE_INCLUSIVE"] = "SALES_AND_SERVICE_INCLUSIVE";
    SUBMISSION_FORM_CALCULATED_FIELDS["FOOD_AND_BEVERAGE_INCLUSIVE"] = "FOOD_AND_BEVERAGE_INCLUSIVE";
})(SUBMISSION_FORM_CALCULATED_FIELDS = exports.SUBMISSION_FORM_CALCULATED_FIELDS || (exports.SUBMISSION_FORM_CALCULATED_FIELDS = {}));
var E_SERVICE_STATUS;
(function (E_SERVICE_STATUS) {
    E_SERVICE_STATUS["AVAILABLE"] = "AVAILABLE";
    E_SERVICE_STATUS["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    E_SERVICE_STATUS["APPLIED"] = "APPLIED";
})(E_SERVICE_STATUS = exports.E_SERVICE_STATUS || (exports.E_SERVICE_STATUS = {}));
// SYSTEM_GENERATED_ENUM_END
//# sourceMappingURL=custom-enums.js.map